import { i18n, setupI18n } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { messages } from '../locales/en/messages';
import { sleep } from './promise';

const SPLASH_SCREEN_ID = 'splash-screen';
const SPLASH_ANIMATION_DURATION = 200;
const SPLASH_DELAY_MS = 10_000;
const fallbackI18n = setupI18n({ locale: 'en', messages: { en: messages } });
let stopRecovery: (() => void) | undefined;

export function initSplashScreen() {
  stopRecovery?.();
  const splashScreen = document.getElementById(SPLASH_SCREEN_ID);
  const recovery = document.getElementById('splash-recovery');
  const status = document.getElementById('splash-status');
  const reload = document.getElementById('splash-reload');
  if (!splashScreen || !recovery || !status || !reload) return;

  const message = msg`Loading is taking longer than expected.`;
  const reloadLabel = msg`Reload`;
  const updateLabels = () => {
    const activeI18n = i18n.locale ? i18n : fallbackI18n;
    status.textContent = activeI18n._(message);
    reload.textContent = activeI18n._(reloadLabel);
  };
  const reloadPage = () => window.location.reload();
  updateLabels();
  const unsubscribe = i18n.on('change', updateLabels);
  reload.addEventListener('click', reloadPage);
  const timeout = window.setTimeout(() => {
    if (!splashScreen.classList.contains('splash-screen-hidden')) {
      recovery.hidden = false;
    }
  }, SPLASH_DELAY_MS);
  stopRecovery = () => {
    window.clearTimeout(timeout);
    unsubscribe();
    reload.removeEventListener('click', reloadPage);
  };
}

export async function hideSplashScreen() {
  stopRecovery?.();
  stopRecovery = undefined;
  const splashScreen = document.getElementById(SPLASH_SCREEN_ID);
  if (!splashScreen) return;

  // Animate splash screen away
  splashScreen.classList.add('splash-screen-hidden');

  // And properly remove it after the animation
  await sleep(SPLASH_ANIMATION_DURATION + 10);
  splashScreen.style.display = 'none';
}
